/**
 * Classes del menu cuando se hace scroll
 */
document.addEventListener('DOMContentLoaded', function () {
  const el_autohide = document.querySelector('.autohide');
  const el_noapply = document.querySelector('.noapplyfixed');

  if (el_autohide) {
    let last_scroll_top = 0;
    window.addEventListener('scroll', function () {
      const scroll_top = window.scrollY;
      if (scroll_top < last_scroll_top) {
        el_autohide.classList.remove('scrolled-down');
        el_autohide.classList.add('scrolled-up');
      } else {
        el_autohide.classList.remove('scrolled-up');
        el_autohide.classList.add('scrolled-down');
      }
      last_scroll_top = scroll_top;
    });
  }

  if (el_noapply) {
    let last_scroll_top_no = 0;
    window.addEventListener('scroll', function () {
      const scroll_top = window.scrollY;
      if (scroll_top < last_scroll_top_no) {
        el_noapply.classList.remove('scrolled-down');
        el_noapply.classList.add('scrolled-up');
      } else {
        el_noapply.classList.remove('scrolled-up');
        el_noapply.classList.add('scrolled-down');
      }
      last_scroll_top_no = scroll_top;
    });
  }
});




/**
 * Corregir funcionamiento de menú multinivel en el menú principal
 **/
document.addEventListener('DOMContentLoaded', function () {
  const mainMenu = document.getElementById('menu-principal');
  if (!mainMenu) return;

  const offcanvas = document.getElementById('offcanvasRight') || mainMenu.closest('.offcanvas');


  const sublevelToggles = mainMenu.querySelectorAll('.dropdown-menu a.dropdown-toggle');
  sublevelToggles.forEach(a => {
    a.removeAttribute('data-bs-toggle');
    a.setAttribute('role', 'button');
    a.setAttribute('aria-expanded', 'false');
  });


  mainMenu.querySelectorAll(':scope > .dropdown > a.dropdown-toggle').forEach(a => {
    a.setAttribute('data-bs-auto-close', 'outside');
  });


  mainMenu.addEventListener('click', function (e) {
    const toggler = e.target.closest('.dropdown-menu a.dropdown-toggle');
    if (!toggler || !mainMenu.contains(toggler)) return;


    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const li = toggler.closest('li');
    const submenu = toggler.nextElementSibling;
    if (!submenu || !submenu.classList.contains('dropdown-menu')) return;


    const parentMenu = li.parentElement;
    parentMenu?.querySelectorAll(':scope > li > .dropdown-menu.show').forEach(m => {
      if (m !== submenu) m.classList.remove('show');
    });


    const willShow = !submenu.classList.contains('show');
    submenu.classList.toggle('show', willShow);
    toggler.setAttribute('aria-expanded', willShow ? 'true' : 'false');


    const topDropdown = li.closest('.dropdown');
    if (topDropdown) {
      topDropdown.classList.add('show');
      const topMenu = topDropdown.querySelector(':scope > .dropdown-menu');
      if (topMenu) topMenu.classList.add('show');
    }
  }, true);


  mainMenu.querySelectorAll(':scope > .dropdown').forEach(d => {
    d.addEventListener('hide.bs.dropdown', () => {
      d.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
      d.querySelectorAll('a[aria-expanded="true"]').forEach(a => a.setAttribute('aria-expanded', 'false'));
    });
  });

  if (offcanvas) {
    offcanvas.addEventListener('hidden.bs.offcanvas', () => {
      mainMenu.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
      mainMenu.querySelectorAll('.dropdown.show').forEach(d => d.classList.remove('show'));
      mainMenu.querySelectorAll('a[aria-expanded="true"]').forEach(a => a.setAttribute('aria-expanded', 'false'));
    });
    offcanvas.addEventListener('show.bs.offcanvas', () => {
      mainMenu.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
      mainMenu.querySelectorAll('.dropdown.show').forEach(d => d.classList.remove('show'));
      mainMenu.querySelectorAll('a[aria-expanded="true"]').forEach(a => a.setAttribute('aria-expanded', 'false'));
    });
  }
});

const offcanvasEl = document.getElementById('offcanvasRight');
const offcanvas = new window.bootstrap.Offcanvas(offcanvasEl, {
  backdrop: true,
  scroll: false,
  keyboard: true
});

offcanvasEl.addEventListener('shown.bs.offcanvas', () => {
  const backdrop = document.querySelector('.offcanvas-backdrop');

  if (backdrop && backdrop.parentElement !== document.body) {
    if (backdrop) {
      backdrop.style.display = 'block';

    }
    document.body.appendChild(backdrop);

  }
});

offcanvasEl.addEventListener('hide.bs.offcanvas', () => {
  const backdrop = document.querySelector('.offcanvas-backdrop');
  if (backdrop) {
    backdrop.style.display = 'none';
  }
});



/**
 * ajustar menú en móvil
 */
document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('header');
  const offcanvas = document.querySelector('.menu-mobile');


  if (!header || !offcanvas) return;

  function adjustOffcanvasHeight() {
    const headerHeight = header.offsetHeight;
    const viewportHeight = window.innerHeight;
    const newHeight = viewportHeight - headerHeight;


    offcanvas.style.height = `${newHeight}px`;
    offcanvas.style.top = `${headerHeight}px`;
  }


  adjustOffcanvasHeight();
  window.addEventListener('resize', adjustOffcanvasHeight);
});




/**
 * menu footer collapse
 */
// Agregar clase collapse en window resize en menú footer
document.addEventListener('DOMContentLoaded', function () {
  activarCollapseFooterMenu();
  window.addEventListener('resize', activarCollapseFooterMenu);
});

function activarCollapseFooterMenu() {
  // habilitar collapse en pantallas menores o iguales a 992
  if (window.innerWidth <= 992) {
    // .nav-footer .dropdown-menu => add 'collapse'
    document.querySelectorAll('.nav-footer .dropdown-menu').forEach(el => {
      el.classList.add('collapse');
    });

    // .nav-footer ul.menu li.menu-item > a.nav-link => data-bs-toggle="collapse"
    document.querySelectorAll('.nav-footer ul.menu li.menu-item > a.nav-link').forEach(a => {
      a.setAttribute('data-bs-toggle', 'collapse');
    });

    // Para cada .menu-item-has-children: setear href/id únicos emparejados
    let count = 0;
    document.querySelectorAll('.nav-footer .menu-item-has-children').forEach(item => {
      const link = item.querySelector(':scope > .nav-link');
      const submenu = item.querySelector(':scope > .dropdown-menu');
      if (link && submenu) {
        const id = `menu_footer_desplegable_${count++}`;
        link.setAttribute('href', `#${id}`);
        submenu.setAttribute('id', id);
      }
    });

    // En subniveles: quitar data-bs-toggle para no colapsar hijos
    document
      .querySelectorAll('.nav-footer .menu .menu-item-has-children .dropdown-menu .menu-item a.nav-link')
      .forEach(a => a.setAttribute('data-bs-toggle', ''));
  } else {
    // Desktop: quitar data-bs-toggle y la clase collapse
    document.querySelectorAll('.nav-footer ul.menu li.menu-item > a.nav-link').forEach(a => {
      a.setAttribute('data-bs-toggle', '');
    });
    document.querySelectorAll('.nav-footer .dropdown-menu').forEach(el => {
      el.classList.remove('collapse');
    });
  }
}





/**
 * Agregar backdrop a submenú de primer nivel en desktop (> 992px)
 * y limpiarlo automáticamente si la ventana baja a ≤ 992px.
 */
(function () {
  const BREAKPOINT = 992;
  let resizeTimer = null;
  let openDropdownCount = 0;

  function createDropdownBackdrop() {
    if (document.querySelector('.dropdown-backdrop')) return;

    const backdrop = document.createElement('div');
    backdrop.className = 'dropdown-backdrop';
    document.body.appendChild(backdrop);

    // Cerrar todos los dropdowns al hacer clic en el backdrop
    backdrop.addEventListener('click', function () {
      closeOpenTopDropdowns();
      removeDropdownBackdrop();
      openDropdownCount = 0;
    });

    requestAnimationFrame(() => backdrop.classList.add('show'));
  }

  function removeDropdownBackdrop() {
    const backdrop = document.querySelector('.dropdown-backdrop');
    if (backdrop) {
      backdrop.classList.remove('show');
      // Si quieres transición suave, déjalo; si no, quita el setTimeout
      setTimeout(() => backdrop.remove(), 200);
    }
  }

  function closeOpenTopDropdowns() {
    document.querySelectorAll('.navbar-nav > .dropdown.show').forEach(li => {
      const toggle = li.querySelector('[data-bs-toggle="dropdown"]');
      const inst = toggle && bootstrap.Dropdown.getInstance(toggle);
      if (inst) inst.hide();
      li.classList.remove('show');
      const menu = li.querySelector(':scope > .dropdown-menu');
      if (menu) menu.classList.remove('show');
    });
  }

  function handleViewportChange() {
    if (window.innerWidth <= BREAKPOINT) {
      closeOpenTopDropdowns();
      removeDropdownBackdrop();
      openDropdownCount = 0;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const topDropdowns = document.querySelectorAll('.navbar-nav > .dropdown');

    topDropdowns.forEach(dropdown => {
      // Cuando un dropdown termina de abrirse
      dropdown.addEventListener('shown.bs.dropdown', function () {
        if (window.innerWidth <= BREAKPOINT) return;

        openDropdownCount++;
        if (openDropdownCount === 1) {
          // El primero en abrir → crear backdrop
          createDropdownBackdrop();
        }
      });

      // Cuando un dropdown termina de cerrarse
      dropdown.addEventListener('hidden.bs.dropdown', function () {
        if (window.innerWidth <= BREAKPOINT) return;

        openDropdownCount = Math.max(0, openDropdownCount - 1);
        if (openDropdownCount === 0) {
          // Ya no queda ninguno abierto → quitar backdrop
          removeDropdownBackdrop();
        }
      });
    });

    // Ejecutar por si se carga ya en móvil
    handleViewportChange();

    // Resize con debounce
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleViewportChange, 120);
    });

    window.addEventListener('orientationchange', handleViewportChange);
  });
})();




/**
 * Menú hamburguesa
 */
document.addEventListener('DOMContentLoaded', function () {
  const offcanvasEl = document.getElementById('offcanvasRight');
  const toggler = document.querySelector('.navbar-toggler.dl-trigger');

  if (!offcanvasEl || !toggler) return;

  // Cuando se abre el offcanvas → convierte a "X"
  offcanvasEl.addEventListener('show.bs.offcanvas', () => {
    toggler.classList.add('is-open');
  });

  // Cuando se cierra el offcanvas → vuelve a "hamburguesa"
  offcanvasEl.addEventListener('hide.bs.offcanvas', () => {
    toggler.classList.remove('is-open');
  });

  // Si el offcanvas inicia abierto (por clases o JS), sincroniza estado
  offcanvasEl.addEventListener('shown.bs.offcanvas', () => {
    toggler.classList.add('is-open');
  });
  offcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
    toggler.classList.remove('is-open');
  });
});






